import React, { useEffect, useState } from "react";
import mondaySdk from "monday-sdk-js";
import "@vibe/core/tokens";
import UpdateVersion from "./update/new_version";
import ErrorPage from "../components/errorPage";
import PageLoader from "../components/PageLoader";
import AddItemDropdown from "../components/addItem/AddItemDropdown";
import { MondayApiQueryInstance } from "../services/monday/monday-service-ts";
import { useErrorWebsocket } from "../hooks/services";
import useUser from "../hooks/context/userHook";
import { useCheckUserOnboarding } from "../hooks/api/useCheckUserOnboarding";

const monday = mondaySdk();

const BoardItemMenu = () => {
  const { userId } = useUser();
  const [itemid, setItemid] = useState(false);
  const [isViewOnly, setIsViewOnly] = useState(false);
  const [version, setVersion] = useState(false);

  const [bigAccount, setBigAccount] = useState(true);

  const { isAuthorized, error } = useCheckUserOnboarding(userId);

  useErrorWebsocket(userId ? String(userId) : "");

  useEffect(() => {
    const fetchAccountSize = async () => {
      try {
        const checkAccountSize = localStorage.getItem("isBigAccount");

        if (checkAccountSize !== null) {
          setBigAccount(JSON.parse(checkAccountSize));
        } else {
          const boardSize = await MondayApiQueryInstance.getAccountSize();

          const isBigAccount = boardSize.length >= 500;

          localStorage.setItem("isBigAccount", JSON.stringify(isBigAccount));
          setBigAccount(isBigAccount);
        }
      } catch (error) {
        throw error;
      }
    };

    fetchAccountSize();
  }, []);

  useEffect(() => {
    monday.execute("valueCreatedForUser");
    monday.get("context").then((res) => {
      let dataVersion = res.data.appVersion.versionData.major;
      //version for force update

      //make the app true
      parseInt(dataVersion) < 27 ? setVersion(false) : setVersion(false);
      res.data.user.isViewOnly ? setIsViewOnly(true) : setIsViewOnly(false);
      let itemidsArray = [];
      res.data.appFeature.type === "AppFeatureItemBatchAction" ? (itemidsArray = res.data.selectedPulsesIds) : itemidsArray.push(res.data.itemId);

      //handle the array here
      setItemid(itemidsArray);
    });
  }, []);
  return (
    <div>
      {isViewOnly ? (
        <div className="flex justify-center items-center h-screen">
          <div className="px-4 py-3 bg-red-100 rounded">
            <span className="block sm:inline">As a viewer, you are unable to use the SIMB.</span>
          </div>
        </div>
      ) : !error ? (
        itemid && isAuthorized ? (
          version ? (
            <UpdateVersion />
          ) : (
            <>
              <AddItemDropdown centered={false} fullWidth={true} bigAccount={bigAccount} stepsEnabled={false} />
            </>
          )
        ) : (
          <div className="App">
            <PageLoader />
          </div>
        )
      ) : (
        <ErrorPage />
      )}
    </div>
  );
};

export default BoardItemMenu;
